module.exports = __webpack_public_path__ + "static/local-community-b223499700ba607ded337d09142de18b.svg";